import lives from "./lives"

const mainHeader = {
  portugues: {
    nav: {
      pageSubscribeLogout: 'ASSINE AGORA',
      pageSubscribeLogin: 'UPGRADE',
      pageSubscribeLoginInactive: 'RENOVAR',
      pageSubscribeLoginInactiveMobile: 'RENOVAR PLANO',
      pageSubscribeLogoutMobile: 'ASSINE AGORA',
      pageSubscribeLoginMobile: 'UP<br>GRADE',
      minhaConta: 'MINHA CONTA',
      freeTour: 'AMOSTRA GRÁTIS',
      creditDownload: 'DOWNLOAD CRÉDITOS',
      login: 'LOGIN',
      models: 'BELLAS',
      makingof: 'MAKING OF',
      lives: 'LIVES',
      videos: 'VÍDEOS',
      inLive: 'ESTAMOS AO VIVO',
      inLiveSticky: 'LIVE'
    }
  },
  ingles: {
    nav: {
      pageSubscribeLogout: 'SUBSCRIBE',
      pageSubscribeLogin: 'UPGRADE',
      pageSubscribeLoginInactive: 'RENEW',
      pageSubscribeLoginInactiveMobile: 'RENEW PLAN',
      pageSubscribeLogoutMobile: 'SUB<br>SCRIBE',
      pageSubscribeLoginMobile: 'UP<br>GRADE',
      minhaConta: 'MY ACCOUNT',
      freeTour: 'FREE SAMPLE',
      creditDownload: 'DOWNLOAD CREDITS',
      login: 'LOGIN',
      models: 'BELLAS',
      makingof: 'MAKING OF',
      lives: 'LIVES',
      videos: 'VIDEOS',
      inLive: 'WE ARE LIVE',
      inLiveSticky: 'LIVE'
    }
  }
}

export default mainHeader
